export enum NAV_LINKS {
  about_me = "about_me",
  experience = "experience",
  education = "education",
}

export const MENU_ITEMS = [
  // { label: "About me", id: NAV_LINKS.about_me },
  // { label: "Experience", id: NAV_LINKS.experience },
  // { label: "Education", id: NAV_LINKS.education },
];
